import { Component } from '@angular/core';

@Component({
    selector: 'app-national-dialog',
    templateUrl: './national-dialog.component.html',
    styleUrls: ['./national-dialog.component.scss'],
    standalone: false
})
export class NationalDialogComponent {
}
